export default __webpack_public_path__ + "static/media/check.7f2e154e.svg";